export default __webpack_public_path__ + "static/media/edit.7c64ce06.svg";